import api from './api'
import {
  CatalogoProdutosResumo,
  ComissoesResumoConsultor,
  PendenciasResumo,
  ReunioesResumo,
} from '@/types/resumos'

/**
 * Clients dos endpoints de resumo do A03 (Onda 2 do plano Figma) — os KPIs das telas do
 * consultor. Todos devolvem o corpo puro (sem envelope `ApiResponse`); o interceptor do
 * `api` já entrega o body.
 *
 * O escopo é do backend: consultor recebe os agregados da própria carteira
 * (`TenantScope` + consultorId), ADMIN/GERENTE o recorte global — a tela não desescopa.
 */
export const resumoService = {
  /** KPIs da Agenda — mesma fonte da listagem de reuniões. */
  reunioes: async (): Promise<ReunioesResumo> =>
    await api.get<ReunioesResumo>('/api/v1/reunioes/resumo'),

  /** KPIs de Pendências e Documentos — mesma fonte da inbox `/v1/pendencias/minhas`. */
  pendencias: async (): Promise<PendenciasResumo> =>
    await api.get<PendenciasResumo>('/api/v1/pendencias/resumo'),

  /** KPIs do Financeiro do consultor — mesma fonte do extrato de comissões. */
  comissoesConsultor: async (): Promise<ComissoesResumoConsultor> =>
    await api.get<ComissoesResumoConsultor>('/api/v1/comissoes/resumo-consultor'),

  /** KPIs de Produtos e Materiais — agregados do catálogo (`GET /v1/produtos`). */
  produtos: async (): Promise<CatalogoProdutosResumo> =>
    await api.get<CatalogoProdutosResumo>('/api/v1/produtos/resumo'),
}
